import { render, staticRenderFns } from "./OrdersListStatsPopup.vue?vue&type=template&id=7e3036b3&scoped=true&"
import script from "./OrdersListStatsPopup.vue?vue&type=script&lang=js&"
export * from "./OrdersListStatsPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListStatsPopup.vue?vue&type=style&index=0&id=7e3036b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3036b3",
  null
  
)

export default component.exports